import { Area, Picker } from 'vant'
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'areaCard',
    data () {
        return {
            areaParams: {
                region_type: 1,
                id: ''
            },
            show: false,
            areaList: {
                province_list: [],
                city_list: [],
                county_list: []
            },
            currentRegionText: '',
            selected_city: '',
            selected_prov: '',
            selected_county: '',
            defaultIndex: {
                province_id: '',
                region_id: '',
                city_id: ''
            }
        }
    },
    props: {
        defaultRegion: {
            type: Object,
            default: {}
        },
        isEdit: 0 // 是否从编辑进来的， 0 非 1 是
        // areaList: {
        //     type: Object,
        //     default: ''
        // }
    },
    watch: {
        defaultRegion (newVal) {
            // 取默认地址
            if (newVal) {
                // this.getRegionAll(newVal)
            }
        },
        areaList (newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.areaList = newVal
                })
            }
        },
        areaParams (n) {
            if (n) {
                this.getRegionList(n)
            }
        },
        'area.province_list' (n) {
            this.getRegionList({
                region_type: 2,
                id: n[0]['id']
            })
            this.selected_prov = n[0]
        },
        'area.city_list' (n) {
            this.getRegionList({
                region_type: 3,
                id: n[0]['id']
            })
            this.selected_city = n[0]
        },
        'area.county_list' (n) {
            this.selected_county = n[0]
        }
    },
    methods: {
        ...mapActions(['getRegion', 'editRegion']),
        // 打开
        open () {
            this.show = true
        },
        // 关闭
        close () {
            this.show = false
        },
        // 确认
        confirm () {
            let { selected_city, selected_prov, selected_county } = this
            this.editRegion({
                selected_city,
                selected_prov,
                selected_county
            })
            this.currentRegionText = `${selected_prov.text} ${
                selected_city.text
            } ${selected_county.text}`
            // this.currentRegionText = this.
            this.$emit('confirm', this.currentRegionText)
            this.close()
        },
        // 取消
        cancel () {
            this.close()
        },
        // 改变
        change () {},
        changeProv (picker) {
            let values = picker.getValues()[0]
            let { id } = values
            this.getRegionList({
                region_type: 2,
                id: id
            })
            this.selected_prov = values
        },
        changeCity (picker) {
            let values = picker.getValues()[0]
            let { id } = values
            this.getRegionList({
                region_type: 3,
                id: id
            })
            this.selected_city = values
        },
        changeArea (picker) {
            let values = picker.getValues()[0]
            this.selected_county = values
        },

        getRegionList (params) {
            this.getRegion({ ...params })
        },
        setParams (data) {
            this.areaParams = data
        }
        // getRegionAll (obj) {
        //     this.getRegionList({
        //         region_type: 1,
        //         id: obj.province_id
        //     })
        //     this.getRegionList({
        //         region_type: 2,
        //         id: obj.city_id
        //     })
        //     this.getRegionList({
        //         region_type: 3,
        //         id: obj.region_id
        //     })
        // }
    },
    created () {},
    activated () {},
    mounted () {
        let { area } = this

        this.setParams({
            region_type: 1,
            id: ''
        })
        Object.assign(this, {
            selected_city: area.selected_city,
            selected_prov: area.selected_prov,
            selected_county: area.selected_county
        })
    },
    components: {
        'van-area': Area,
        'van-picker': Picker
    },
    computed: {
        ...mapGetters(['area', 'user'])
    }
}
